function getQuerystring(query) {
  let querystring = Object.keys(query)
    .map((key) => `${key}=${encodeURIComponent(query[key])}`)
    .join('&');
  querystring = querystring ? `?${querystring}` : '';

  return querystring;
}

class Adapter {
  constructor(dependencyHash) {
    const { authCommonAdapter, axios, env, Promise } = dependencyHash;

    this.authCommonAdapter = authCommonAdapter;
    this.axios = axios;
    this.Promise = Promise;

    this.apiUrl = env.API_URL;
  }

  getIdToken() {
    return `Bearer ${this.authCommonAdapter.getIdToken()}`;
  }

  getRefreshToken() {
    return `Bearer ${this.authCommonAdapter.getRefreshToken()}`;
  }

  getXClientSubdomain() {
    return this.authCommonAdapter.getXClientSubdomain();
  }

  async deleteUser(argHash) {
    const { query } = argHash;
    const querystring = getQuerystring(query);
    const url = `/v1/users/${querystring}`;
    const axiosConfig = {
      method: 'DELETE',
      baseURL: this.apiUrl,
      url,
      headers: {
        authorization: this.getIdToken(),
        'x-client-subdomain': this.getXClientSubdomain()
      }
    };
    const axiosResponse = await this.axios(axiosConfig);
    return axiosResponse;
  }

  async getGroupList(argHash) {
    const { query } = argHash;
    const querystring = getQuerystring(query);
    const url = `/v1/groups${querystring}`;
    const axiosConfig = {
      method: 'GET',
      baseURL: this.apiUrl,
      url,
      headers: {
        authorization: this.getIdToken(),
        'x-client-subdomain': this.getXClientSubdomain()
      }
    };
    const axiosResponse = await this.axios(axiosConfig);
    return axiosResponse;
  }

  async getHealthAlive() {
    const url = `/health/alive`;
    const axiosConfig = {
      method: 'GET',
      baseURL: this.apiUrl,
      url
    };
    const axiosResponse = await this.axios(axiosConfig);
    return axiosResponse;
  }

  async getUserAuthRefresh() {
    const url = '/v1/users/auth/refresh';
    const axiosConfig = {
      method: 'GET',
      baseURL: this.apiUrl,
      url,
      headers: {
        authorization: this.getRefreshToken(),
        'x-client-subdomain': this.getXClientSubdomain()
      }
    };
    const axiosResponse = await this.axios(axiosConfig);
    return axiosResponse;
  }

  async getUserInfo(argHash) {
    const { query } = argHash;
    const querystring = getQuerystring(query);
    const url = `/v1/users/info${querystring}`;
    const axiosConfig = {
      method: 'GET',
      baseURL: this.apiUrl,
      url,
      headers: {
        authorization: this.getIdToken(),
        'x-client-subdomain': this.getXClientSubdomain()
      }
    };
    const axiosResponse = await this.axios(axiosConfig);
    return axiosResponse;
  }

  async getUserList(argHash) {
    const { query } = argHash;
    const querystring = getQuerystring(query);
    const url = `/v1/users${querystring}`;
    const axiosConfig = {
      method: 'GET',
      baseURL: this.apiUrl,
      url,
      headers: {
        authorization: this.getIdToken(),
        'x-client-subdomain': this.getXClientSubdomain()
      }
    };
    const axiosResponse = await this.axios(axiosConfig);
    return axiosResponse;
  }

  async getUserSubscribedApps(argHash) {
    const { query } = argHash;
    const querystring = getQuerystring(query);
    const url = `/v1/users/apps${querystring}`;
    const axiosConfig = {
      method: 'GET',
      baseURL: this.apiUrl,
      url,
      headers: {
        'x-client-subdomain': this.getXClientSubdomain()
      }
    };
    const axiosResponse = await this.axios(axiosConfig);
    return axiosResponse;
  }

  async postUser(argHash) {
    const { payload } = argHash;
    const url = '/v1/users';
    const axiosConfig = {
      method: 'POST',
      baseURL: this.apiUrl,
      url,
      data: payload,
      headers: {
        authorization: this.getIdToken(),
        'Content-Type': 'application/json',
        'x-client-subdomain': this.getXClientSubdomain()
      }
    };
    const axiosResponse = await this.axios(axiosConfig);
    return axiosResponse;
  }

  async postUserAuthLogin(argHash) {
    const { payload } = argHash;
    const url = '/v1/users/auth/login';
    const axiosConfig = {
      method: 'POST',
      baseURL: this.apiUrl,
      url,
      data: payload,
      headers: {
        'Content-Type': 'application/json',
        'x-client-subdomain': this.getXClientSubdomain()
      }
    };
    const axiosResponse = await this.axios(axiosConfig);
    return axiosResponse;
  }

  async postUserInviteResend(argHash) {
    const { query } = argHash;
    const querystring = getQuerystring(query);
    const url = `/v1/users/invite/resend${querystring}`;
    const axiosConfig = {
      method: 'POST',
      baseURL: this.apiUrl,
      url,
      headers: {
        authorization: this.getIdToken(),
        'Content-Type': 'application/json',
        'x-client-subdomain': this.getXClientSubdomain()
      }
    };
    const axiosResponse = await this.axios(axiosConfig);
    return axiosResponse;
  }

  async putUser(argHash) {
    const { payload, query } = argHash;
    const querystring = getQuerystring(query);
    const url = `/v1/users${querystring}`;
    const axiosConfig = {
      method: 'PUT',
      baseURL: this.apiUrl,
      url,
      data: payload,
      headers: {
        authorization: this.getIdToken(),
        'Content-Type': 'application/json',
        'x-client-subdomain': this.getXClientSubdomain()
      }
    };
    const axiosResponse = await this.axios(axiosConfig);
    return axiosResponse;
  }

  async putUserEnabled(argHash) {
    const { payload, query } = argHash;
    const querystring = getQuerystring(query);
    const url = `/v1/users/enabled${querystring}`;
    const axiosConfig = {
      method: 'PUT',
      baseURL: this.apiUrl,
      url,
      data: payload,
      headers: {
        authorization: this.getIdToken(),
        'Content-Type': 'application/json',
        'x-client-subdomain': this.getXClientSubdomain()
      }
    };
    const axiosResponse = await this.axios(axiosConfig);
    return axiosResponse;
  }
}

export default {
  Adapter
};
